<template>
  <div class="d-flex align-items-center text-muted pe-3">
    <template v-if="publicationSavingState === 'saving'">
      <IconLoader class="icon-spin me-1" :size="18" />
      <span>{{ $t('app.saving') }}...</span>
    </template>
    <template v-else-if="publicationSavingState === 'saved'">
      <IconCheck class="text-success me-1" :size="18" />
      <span>{{ $t('app.saved') }}</span>
    </template>
    <template v-else-if="publicationSavingState === 'error'">
      <IconAlertCircle class="text-danger me-1" :size="18" />
      <span>{{ $t('app.save_error') }}</span>
    </template>
    <template v-else-if="publicationSavingState === 'typing'">
      <IconPencil class="me-1" :size="18" />
      <span>{{ $t('app.unsaved_changes') }}</span>
    </template>
    <template v-else>
      <IconCheck class="text-success me-1" :size="18" />
      <span>{{ $t('app.all_changes_saved') }}</span>
    </template>
  </div>
</template>
<script lang="ts" setup>
import { useOrderCreationStore } from '@/stores/orderCreation';
import { IconAlertCircle, IconCheck, IconLoader, IconPencil } from '@tabler/icons-vue';
import { storeToRefs } from 'pinia';

const orderCreationStore = useOrderCreationStore();
const { publicationSavingState } = storeToRefs(orderCreationStore);
</script>
